// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InternalVacanciesList {
  width: 100%;
  justify-content: center;
  top: 50% !important;
  left: 50% !important;
  padding: 20px;
}
.InternalVacanciesList .color-purple {
  color: #7A6BE8;
}
.InternalVacanciesList .volver-btn {
  margin: -43px 0px 15px -70px;
}
.InternalVacanciesList h4 {
  font-weight: bold;
}
.InternalVacanciesList .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
}
.InternalVacanciesList > .card {
  border-color: #3fc3fd;
  border-radius: 15px;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);
  padding: 50px 80px;
  position: relative;
  max-height: auto;
}
.InternalVacanciesList > .card .logo {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 50px;
  height: 50px;
  border: 1px solid rgb(64, 194, 255);
  border-radius: 50rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}
.InternalVacanciesList > .card .logo img {
  border-radius: 50rem;
  width: 100%;
}
.InternalVacanciesList .content-input {
  display: flex;
}
.InternalVacanciesList .btn-arrow {
  color: white;
  background: none;
  border: none;
  border-radius: 0 50rem 50rem 0;
  padding: 0 30px;
}
.InternalVacanciesList .btn-arrow:hover {
  background: rgba(0, 0, 0, 0.05);
}
.InternalVacanciesList .btn-add {
  background-color: #7a6be8;
  color: white;
  border: 2px solid #7a6be8;
  height: 38px;
}
.InternalVacanciesList .btn-add:hover {
  background-color: #7a6be8;
  color: white;
}
.InternalVacanciesList .btnLoadMore {
  background-color: #D9D9E2;
}
.InternalVacanciesList .btnLoadMore:hover {
  background-color: #9391A1;
  color: white;
}
.InternalVacanciesList .search-bar-dropdown button {
  color: white;
  background: none;
  border: none;
  border-radius: 0 50rem 50rem 0;
  padding: 0 30px;
}
.InternalVacanciesList .search-bar-dropdown button:hover {
  background: rgba(0, 0, 0, 0.05);
}
.InternalVacanciesList .dropdrown-size {
  width: 500px;
}
.InternalVacanciesList .dataResult {
  margin-top: 5px;
  border-radius: 15px 15px 15px 15px;
  width: 500px;
  height: auto;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow-y: auto;
}
.InternalVacanciesList .dataResult ::-webkit-scrollbar {
  display: none;
}
.InternalVacanciesList .dataResult .dataItens {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: black;
  list-style: none;
}
.InternalVacanciesList .dataResult .dataItens:hover {
  background: linear-gradient(90deg, rgba(64, 194, 255, 0.3) 0%, rgba(51, 215, 217, 0.3) 100%);
}
.InternalVacanciesList .alertNoVacancies {
  background-color: #D9D9E2;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Views/InternalVacanciesList/InternalVacanciesList.sass"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;AACJ;AACI;EACI,cAAA;AACR;AACI;EACI,4BAAA;AACR;AACI;EACI,iBAAA;AACR;AACI;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AACR;AACI;EACI,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACR;AACQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACZ;AACY;EACI,oBAAA;EACA,WAAA;AAChB;AACI;EACI,aAAA;AACR;AACI;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AACR;AAAQ;EACI,+BAAA;AAEZ;AAAI;EACI,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AAER;AAAQ;EACI,yBAAA;EACA,YAAA;AAEZ;AAAI;EACI,yBAAA;AAER;AADQ;EACI,yBAAA;EACA,YAAA;AAGZ;AACQ;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AACZ;AACY;EACI,+BAAA;AAChB;AACI;EACI,YAAA;AACR;AACI;EACI,eAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,4CAAA;EACA,gBAAA;AACR;AACQ;EACI,aAAA;AACZ;AACQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACZ;AACY;EACI,4FAAA;AAChB;AACI;EACI,yBAAA;AACR","sourcesContent":[".InternalVacanciesList\n    width: 100%\n    justify-content: center\n    top: 50% !important\n    left: 50% !important\n    padding: 20px\n\n    .color-purple\n        color: #7A6BE8\n\n    .volver-btn\n        margin:-43px 0px 15px -70px\n\n    h4\n        font-weight: bold\n\n    .icon\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        padding: 8px\n        margin: 0 10px\n\n    & > .card\n        border-color: #3fc3fd\n        border-radius: 15px\n        box-shadow: 0 5px 8px rgba(0,0,0,.15)\n        padding: 50px 80px\n        position: relative\n        max-height: auto\n\n        .logo\n            position: absolute\n            top: -18px\n            right: -18px\n            width: 50px\n            height: 50px\n            border: 1px solid rgb(64,194,255)\n            border-radius: 50rem\n            overflow: hidden\n            display: flex\n            align-items: center\n            justify-content: center\n            background: white\n\n            img\n                border-radius: 50rem\n                width: 100%\n\n    .content-input\n        display: flex\n\n    .btn-arrow\n        color: white\n        background: none\n        border: none\n        border-radius: 0 50rem 50rem 0\n        padding: 0 30px\n        &:hover\n            background: rgba(0,0,0,.05)\n\n    .btn-add\n        background-color: #7a6be8\n        color: white\n        border: 2px solid #7a6be8\n        height: 38px\n\n        &:hover\n            background-color: #7a6be8\n            color: white\n\n    .btnLoadMore\n        background-color: #D9D9E2\n        &:hover\n            background-color: #9391A1\n            color: white\n\n    .search-bar-dropdown\n\n        button\n            color: white\n            background: none\n            border: none\n            border-radius: 0 50rem 50rem 0\n            padding: 0 30px\n\n            &:hover\n                background: rgba(0,0,0,.05)\n\n    .dropdrown-size\n        width: 500px\n\n    .dataResult\n        margin-top: 5px\n        border-radius: 15px 15px 15px 15px\n        width: 500px\n        height: auto\n        background-color: white\n        box-shadow: rgba(0,0,0,0.35) 0px 5px 15px\n        overflow-y: auto\n\n        & ::-webkit-scrollbar\n            display: none\n\n        & .dataItens\n            width: 100%\n            height: 50px\n            display: flex\n            align-items: center\n            color: black\n            list-style: none\n\n            &:hover\n                background: linear-gradient(90deg, rgba(64,194,255,0.3) 0%, rgba(51,215,217,0.3) 100%)\n\n    .alertNoVacancies\n        background-color: #D9D9E2"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
